import { PlatformAppsApiClient } from '@fourthwall/services/dist/PlatformAppsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

const usePlatformAppClientsQuery = createQueryHook(PlatformAppsApiClient.getPlatformAppClients, {
  queryKey: ['platformAppClients'],
})

export const usePlatformAppClients = () => {
  const { platformAppClientsQuery } = usePlatformAppClientsQuery()

  return {
    data: platformAppClientsQuery.data,
    isLoading: platformAppClientsQuery.isLoading,
    refetch: platformAppClientsQuery.refetch,
  }
}
